import { render, staticRenderFns } from "./PerformanceTrendPanel.vue?vue&type=template&id=08d4c5c0&scoped=true"
import script from "./PerformanceTrendPanel.vue?vue&type=script&lang=js"
export * from "./PerformanceTrendPanel.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTrendPanel.vue?vue&type=style&index=0&id=08d4c5c0&prod&scoped=true&lang=css"
import style1 from "./PerformanceTrendPanel.vue?vue&type=style&index=1&id=08d4c5c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4c5c0",
  null
  
)

export default component.exports